import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Use localStorage
import index from "./reducers";

const persistConfig = {
  key: "root", // Key for storing persist data
  storage,
};

const persistedReducer = persistReducer(persistConfig, index);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Keep this to avoid warnings
    }),
});

export const persistor = persistStore(store);
